<template>
    <div class="proposal">
        <div class="type">
            {{ typeName }}
        </div>
        <div
            class="status"
            :class="{ ['status--'+item.status]: true }"
        >
            {{ statusName }}
        </div>
        <div class="name">{{ item.name }}</div>
        <div class="thematic_directions">
            Тематические направления: {{ thematicDirectionsString }}
        </div>
        <div class="link">
            <router-link
                :to="{ name: 'proposal', params: { id: item.id } }"
            >Перейти к заявке</router-link>
        </div>
    </div>
</template>

<script>

import {mapGetters, mapState} from 'vuex';

export default {
    name: 'MineProposals',
    props: {
        item: Object,
    },
    data: () => ({
        statuses: {
            'new': 'Новая',
            'in_review': 'На рассмотрении',
            'in_revision': 'На доработке',
            'reserved': 'Отправлена в резерв',
            'rejected': 'Отклонена',
            'approved': 'Утверждена',
        },
    }),
    computed: {
        ...mapState('proposals', [
            'projectTypes',
        ]),
        ...mapGetters([
            'dictionaryByType',
        ]),
        getDictionaryItem() {
            return (id) => this.dictionaryByType('projects_thematic_directions').find(v => v.id === id);
        },
        typeName() {
            return this.projectTypes[this.item.type];
        },
        statusName() {
            return this.statuses[this.item.status];
        },
        thematicDirectionsString() {
            return this.item.thematicDirections.map(v=> this.getDictionaryItem(v).field_value).join(', ');
        },
    },
};
</script>

<style lang="scss" scoped>
    @import "../../../../styles/variables";
    @import '../../../../styles/rem';
    @import '../../../../styles/mrem';

   .proposal {
       background: #FFFFFF;
       border: 1px solid #D2D5D9;
       box-sizing: border-box;
       border-radius: rem(4);
       display: flex;
       flex-direction: row;
       flex-wrap: wrap;
       padding: rem(24);
       justify-content: space-between;
       margin-bottom: rem(24);

       @include on-mobile {
           border: none;
           margin-bottom: mrem(40);
       }

       .type {
           max-width: 70%;
           font-family: "Open Sans", sans-serif;
           font-style: normal;
           font-weight: 600;
           font-size: rem(16);
           line-height: rem(24);
           color: #98A0A9;

           @include on-mobile {
               max-width: none;
               width: 100%;
               font-size: mrem(16);
               line-height: mrem(24);
               margin-top: mrem(16);
           }
       }

       .status {
           max-width: 30%;
           background: #AD98FF;
           border-radius: rem(4);
           padding: rem(6) rem(12);
           font-family: "Open Sans", sans-serif;
           font-style: normal;
           font-weight: 600;
           font-size: rem(15);
           line-height: rem(20);
           color: #FFFFFF;

           @include on-mobile {
               max-width: none;
               width: auto;
               order: -1;
               border-radius: mrem(4);
               padding: mrem(6) mrem(12);
               font-size: mrem(15);
               line-height: mrem(20);
           }

           &--new {
               background: #89C8E9;
           }
           &--in_review {
               background: #AD98FF;
           }
           &--in_revision {
               background: #ECB447;
           }
           &--rejected {
               background: #EF627D;
           }
           &--reserved {
               background: #448DE2;
           }
           &--approved {
               background: #70D365;
           }
       }

       .name {
           width: 100%;
           font-family: "Open Sans", sans-serif;
           font-style: normal;
           font-weight: 600;
           font-size: rem(18);
           line-height: rem(26);
           color: #2A2626;
           margin-top: rem(8);

           @include on-mobile {
               font-size: mrem(18);
               line-height: mrem(26);
               margin-top: mrem(12);
           }
       }

       .thematic_directions {
           width: 100%;
           font-family: "Open Sans", sans-serif;
           font-style: normal;
           font-weight: normal;
           font-size: rem(16);
           line-height: rem(24);
           color: #2A2626;
           margin-top: rem(12);

           @include on-mobile {
               font-size: mrem(16);
               line-height: mrem(24);
               margin-top: mrem(12);
           }
       }

       .link {
           width: 100%;
           display: flex;
           flex-direction: row-reverse;
           margin-top: rem(8);

           @include on-mobile {
               margin-top: mrem(16);
           }

           a {
               font-family: "Open Sans", sans-serif;
               font-style: normal;
               font-weight: 600;
               font-size: rem(15);
               line-height: rem(22);
               color: #4663AB;
               padding-bottom: rem(4);
               border-bottom: 1px solid #4663AB;

               @include on-mobile {
                   text-align: center;
                   font-size: mrem(14);
                   line-height: mrem(40);
                   border: 1px solid #4663AB;
                   border-radius: mrem(4);
                   display: block;
                   width: 100%;
               }
           }
       }
   }
</style>
